/**
 * @generated SignedSource<<b154cb8b9d8e3e5eb30ef59badd3eaa9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchAssistantMessageFragment$data = {
  readonly externalSources: {
    readonly totalCount: number;
  } | null;
  readonly id: string;
  readonly messageText: string;
  readonly sources: {
    readonly totalCount: number;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMessageFeedbackFooterFragment">;
  readonly " $fragmentType": "BrainSearchAssistantMessageFragment";
};
export type BrainSearchAssistantMessageFragment$key = {
  readonly " $data"?: BrainSearchAssistantMessageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchAssistantMessageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchAssistantMessageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageText",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchMessageFeedbackFooterFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrainSearchMessageSourceNodeConnection",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrainSearchMessageExternalSourceNodeConnection",
      "kind": "LinkedField",
      "name": "externalSources",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "BrainSearchMessage",
  "abstractKey": null
};
})();

(node as any).hash = "fb6531b732e20ba4af71e62d2706ebf6";

export default node;
